import { render, staticRenderFns } from "./WebPagesBlockSelector.vue?vue&type=template&id=0b665fdd&"
import script from "./WebPagesBlockSelector.vue?vue&type=script&lang=js&"
export * from "./WebPagesBlockSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports